module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ie right-col u-full-height--passport u-d-block",
    class: {
      'p-homepage': _vm.isHomePage, 'right-col--collapse-menu': _vm.isMenuCollapsed
    }
  }, [_c('icons'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b1bd17f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightCol.vue
// module id = 1794
// module chunks = 0